import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import { fetchLoadUnload, fetchDriverDetail } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import CustomerMaster from "./CustomerMaster";
import LedgerMaster from "./LedgerMaster";
import TripItemEntry from "./TripItemEntry";
import CtART from "./CustomTool/ResponsiveTable";

class DriverMaster extends Component {
  state = {
    formData: {
      bint_srno: "",
      txtDriver: "",
      txtLicenceno: "",
      txtMobileno: "",
    },

    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "Sr no.",
      },
      {
        accessorKey: "vac_driver",
        header: " Driver Name",
      },
      {
        accessorKey: "vac_licenceno",
        header: "Licence No",
      },
      {
        accessorKey: "vac_mobileno",
        header: " Mobile No",
      },
    ],
    rows: [],
    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,
    rowsOtherDetail: [],
    rowsCountOtherDetail: 0,
    rowsPerPageOtherDetail: 10,
    dataLoadStatus: true,
    ARD: null,
  };

  componentDidMount() {
    {
      !this.props.showHeading &&
        (document.title = "RiTe Account : Driver Master");
    }
    this.props.setActiveMenu("DriverMaster");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          maxWidthClass={"xl"}
          labelDisagree="Close"
          // New : Sales Item Entry'
          alertMessage={<TripItemEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      // excludeKeysArray: [""],
      numberKeysArray: ["txtMobileno"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadDriver",
        bint_acid: localStorage.getItem("acid"),
      };
      fetchDriverDetail(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          if (res.data.DriverList && res.data.DriverList.length > 0) {
            rows = res.data.DriverList;
            rowsCount = rows.length;
          }
          this.setState({
            dataLoadStatus,
            rows,
            rowsCount,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtDriver").focus();
  };

  clearInfo = () => {
    let bint_srno = "",
      txtDriver = "",
      txtLicenceno = "",
      txtMobileno = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno,
          txtDriver,
          txtLicenceno,
          txtMobileno,
        },
      },
      () => {
        document.getElementById("txtDriver").focus();
      }
    );
  };

  validatDriverMaster = () => {
    const { txtDriver } = this.state.formData;

    if (!txtDriver.trim()) {
      this.props.toastErrorMsg("Enter Driver", "txtDriver");
      return false;
    } else if (
      this.state.formData.txtLicenceno.length !== 0 &&
      this.state.formData.txtLicenceno.length < 16
    ) {
      this.props.toastErrorMsg("Enter 16 Digit Licence No", "txtLicenceno");
      return false;
    } else if (
      this.state.formData.txtMobileno !== 0 &&
      this.state.formData.txtMobileno.length < 10
    ) {
      this.props.toastErrorMsg("Enter 10 Digit Mobile No", "txtMobileno");
      return false;
    }
    return true;
  };

  handleARDonActionClick_Edit = (row) => {
    console.log("row", row);
    // console.log('row.original["bint_srno"]', row.original["bint_srno"]);
    const bint_srno = row.getValue("bint_srno"),
      txtDriver = row.getValue("vac_driver"),
      txtLicenceno = row.getValue("vac_licenceno"),
      txtMobileno = row.getValue("vac_mobileno");
    // const rows2 = row.original.CheckToDoList;
    // console.log("rows2", rows2);
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txtDriver,
        txtLicenceno,
        txtMobileno,
      },
    });
    window.scrollTo(0, 0);
    document.getElementById("txtDriver").focus();
  };

  SaveDriver = () => {
    this.trimFormData(() => {
      if (this.validatDriverMaster()) {
        let dataLoadStatus = false;
        this.props.notifyProcessing();
        this.setState({ dataLoadStatus: false }, () => {
          const reqData = {
            Op: "SaveDriver",
            bint_acid: localStorage.getItem("acid"),
            bint_srno: this.state.formData.bint_srno,
            vac_driver: this.state.formData.txtDriver
              .trim()
              .split(" ")
              .map(
                (word) =>
                  word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
              )
              .join(" "),
            vac_licenceno: this.state.formData.txtLicenceno,
            vac_mobileno: this.state.formData.txtMobileno,
            bint_acyear: localStorage.getItem("ACY"),
            vac_company: localStorage.getItem("CompanyName"),
            dec_opbalancecrdr: "DR",
          };
          fetchDriverDetail(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              let dataLoadStatus = true,
                rows = this.state.rows,
                rowsCount = rows.length;
              if (res.data.msgType === "success") {
                if (res.data.DriverList && res.data.DriverList.length > 0) {
                  rows = res.data.DriverList;
                  rowsCount = rows.length;
                }
              }
              this.setState(
                {
                  dataLoadStatus,
                  rows,
                  rowsCount,
                },
                () => {
                  if (res.data.msgType === "success") {
                    this.clearInfo();
                  }
                }
              );
            })
            .catch((error) => {
              console.log("Unknown error occurred in SaveDriverMaster.", error);
            });
        });
      }
    });
  };

  handleARDonActionClick_Delete = (row) => {
    const bint_srno = row.getValue("bint_srno"),
      Driver = row.getValue("vac_driver"),
      LicenceNo = row.getValue("vac_"),
      MobileNo = row.getValue("vac_remark");
    this.DeleteData(bint_srno, Driver, LicenceNo, MobileNo);
  };
  DeleteData = (bint_srno, Driver) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={"Do you want to Delete Driver : " + Driver + " ?"}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteDriver(bint_srno, Driver);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };
  DeleteDriver = (bint_srno, Driver) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteDriver",
      bint_acid: localStorage.getItem("acid"),
      bint_srno: bint_srno,
      vac_driver: Driver,
      // bol_list: true,
    };
    fetchDriverDetail(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.DeleteList && res.data.DeleteList.length > 0) {
            rows = res.data.DeleteList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.onFormLoad();
              this.clearInfo();
            }
          );
          document.getElementById("txtDriver").focus();
        }
      })

      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Check list. " + error
        );
      });
    return false;
  };
  handleChangeRowsPerPage = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };
  handleOnRowDataChange = (rowsOtherDetail) => {
    this.setState({
      rowsOtherDetail,
      rowsCountOtherDetail: rowsOtherDetail.length,
    });
  };
  render() {
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {this.props.showHeading == true && (
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            className="title"
          >
            <label
              htmlFor="Title"
              style={{ fontSize: "25px", color: "#6f7689" }}
            >
              <b>Driver Master</b>
            </label>
          </Grid>
        )}

        <Grid
          container
          direction="column"
          spacing={2}
          // marginTop={0}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid item>
                <CtTxt
                  id="txtDriver"
                  value={this.state.formData.txtDriver}
                  handleOnChange={this.handleOnChange}
                  label="Driver*"
                  width={300}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"txtLicenceno"}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              spacing={2}
              marginTop={0}
              justifyContent="flex-start"
              alignItems="center"
            >
              {" "}
              <Grid item>
                <CtTxt
                  id="txtLicenceno"
                  value={this.state.formData.txtLicenceno}
                  handleOnChange={this.handleOnChange}
                  label="Licence No."
                  width={175}
                  maxLength={16}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"txtMobileno"}
                />
              </Grid>
              <Grid item>
                <CtTxtNum
                  id="txtMobileno"
                  value={this.state.formData.txtMobileno}
                  handleOnChange={this.handleOnChange}
                  label="Mobile No."
                  width={108}
                  maxLength={10}
                  onKeyDown={this.props.onKeyDown}
                  defaultAction={this.SaveDriver}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              // justifyContent="flex-start"
              alignItems="flex-start"
              spacing={2}
              margin={1}
            >
              <Grid item>
                <CtBtn label="Save" onClick={this.SaveDriver} />
              </Grid>

              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant={"outlined"}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtDriver
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />

        <Grid item marginTop={3} className="maintable">
          <CtART
            rowsdata={this.state.rows}
            columnsdata={this.state.columnsdata}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("DriverMaster")}
            rowIconAction={[
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
            ]}
            showColumnFilters={false}
            actionColSize={20}
            hideColIdList={["bint_srno"]}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(DriverMaster))));
